import { createContext } from "react";
import type { ReactZoomPanPinchRef } from "react-zoom-pan-pinch";

const TransformContext = createContext<ReactZoomPanPinchRef | null>(null);

export default TransformContext;
